import React from 'react';
import {ErrorMessage, Form, Formik} from 'formik';
import {Link} from 'react-router-dom';
import InputText from 'components/InputText';
import Button from 'components/Button';
import Title from 'components/Typography/Title';
import {ErrorIcon, ArrowIcon} from 'icons';

import Agreement from '../../components/Agreement';
import FacebookButton from '../../components/FacebookButton';
import AuthForm from '../../components/AuthForm';
import validate from './signInValidations';
import {signInWithEmailAndPassword} from './signInHelpers';
import './singIn.scss';

const initialValues = {email: '', password: ''};

export default ({history}) => (
  <AuthForm className="sign-in">
    <Formik initialValues={initialValues} validate={validate} onSubmit={signInWithEmailAndPassword(history)}>
      {({isSubmitting, isValid, submitCount, setErrors, setSubmitting, setStatus, status}) => (
        <Form>
          <Title text="Login" />
          <InputText type="email" name="email" placeholder="Email Address" />
          <InputText type="password" name="password" placeholder="Password" />
          <footer>
            <Link to="/forgot-password" className="forgot-password">
              Forgot Password
            </Link>
            <Button disabled={isSubmitting}>
              Login <ArrowIcon />
            </Button>
            <FacebookButton
              onClick={() => {
                setStatus('fb');
              }}
              onError={err => {
                setSubmitting(false);
                setErrors({email: err.message});
                setStatus(null);
                console.warn(err);
              }}
            />
          </footer>

          {/* TODO create unit test */}
          {status !== 'fb' && submitCount > 0 && !isValid && (
            <div className="errors">
              <ErrorIcon />
              <ErrorMessage name="email" />
              <ErrorMessage name="password" />
            </div>
          )}
        </Form>
      )}
    </Formik>
    <Agreement action="Login or Continue" />
  </AuthForm>
);
